import { Link } from "react-router-dom";
import { ASSETS, CONTACT_EMAIL } from "@/lib/assets";

export const Footer = () => (
  <footer className="border-t border-[#eadfd2] bg-[var(--paper)]">
    <div className="mx-auto flex max-w-6xl flex-col gap-8 px-6 py-12 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex items-center gap-3">
        <img src={ASSETS.logo} alt="Domaya logo" className="h-9 w-9 rounded-lg object-cover" />
        <div>
          <p className="font-display text-xl font-semibold text-[var(--olive-deep)]">Domaya</p>
          <p className="text-xs text-[var(--ink-soft)]">A calm household hub</p>
        </div>
      </div>

      <nav className="flex flex-wrap items-center gap-x-8 gap-y-3 text-sm text-[var(--ink-soft)]">
        <Link to="/privacy" data-testid="footer-privacy-link" className="transition-colors hover:text-[var(--olive)]">
          Privacy Policy
        </Link>
        <Link to="/terms" data-testid="footer-terms-link" className="transition-colors hover:text-[var(--olive)]">
          Terms of Service
        </Link>
        <a
          href={`mailto:${CONTACT_EMAIL}`}
          data-testid="footer-contact-link"
          className="transition-colors hover:text-[var(--olive)]"
        >
          {CONTACT_EMAIL}
        </a>
      </nav>
    </div>
    <div className="border-t border-[#f1e8dc] py-5 text-center text-xs text-[var(--ink-soft)]">
      © {new Date().getFullYear()} Domaya. All rights reserved.
    </div>
  </footer>
);
